import classname from 'classnames/bind';
import styles from './tab.module.sass';

const cx = classname.bind(styles);

export const Tabs = ({ className, style, value: _value, onTabChange, list }) => {
  return (
    <div className={cx(styles.tabs, className)} style={style}>
      {list.map(item => {
        const { key, value } = item;
        const className = cx({
          tab: true,
          active: _value === key,
        });

        return (
          <div
            className={className}
            onClick={() => {
              onTabChange(key);
            }}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
};
